import { Injectable } from '@angular/core';
import { HttpClientService } from './http-client.service';
import { Observable } from 'rxjs';
import { FichaMedicaAvances } from '../models/fichaMedicaAvances';
import { environment } from '../../environments/environment';

const fichaUrl = environment.hostService + '/FichaMedicaAvances';

@Injectable({
  providedIn: 'root'
})
export class FichaMedicaAvancesService {

  constructor(private _http: HttpClientService) { }

  getAll(): Observable<any>
  {
    return this._http.get<any>({ url: fichaUrl + '/Index' })
  }

  save(entidad: FichaMedicaAvances)
  {
    return this._http.post({ url: fichaUrl + '/Save', body: entidad });
  }

  delete(id: number)
  {
    return this._http.get<any>({ url: fichaUrl + '/Delete?id=' + id });   
  }

  GetByFicha(code): Observable<any> {
    return this._http.get<any>({ url: fichaUrl + '/GetByFicha?fichaMedicaId=' + code })
  }

}

